/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_Access_Self_Missing_DescriptionInputs */



/**
* | output |
* | --- |
* | "You are missing access to {count} linked knowledge source(s). AI answers in this project may be incomplete. Contact your project admin to request access." |
*
* @param {Project_Access_Self_Missing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_access_self_missing_description = /** @type {((inputs: Project_Access_Self_Missing_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Access_Self_Missing_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dir fehlt der Zugriff auf ${i?.count} verknüpfte Wissensquelle(n). KI-Antworten in diesem Projekt können unvollständig sein. Kontaktiere deinen Projektadmin, um Zugriff anzufordern.`)
	return /** @type {LocalizedString} */ (`You are missing access to ${i?.count} linked knowledge source(s). AI answers in this project may be incomplete. Contact your project admin to request access.`)
});